import { useCallback } from 'react';

import {
  ForwardPinnedItemsConfig,
  ForwardPinnedItemsConfigOptions,
} from '@/forwarding/entities/ForwardConfig/ForwardPinnedItemsConfig';
import { PinnedItem } from '@/forwarding/entities/PinnedItem/PinnedItem';
import { usePinnedItemsDtoStore } from '@/forwarding/stores/PinnedItemsDtoStore';

export function useForwardPinnedItemsConfig() {
  const { fetchIfMissing } = usePinnedItemsDtoStore();

  return useCallback(
    (pinnedItems: PinnedItem[], options?: ForwardPinnedItemsConfigOptions) => {
      return new ForwardPinnedItemsConfig(pinnedItems, fetchIfMissing(pinnedItems), options);
    },
    [fetchIfMissing],
  );
}
